<template>
  <div>
    <b-card class="col-lg-6 container">
			<h1 class="pb-3 text-center">ลืมรหัสผ่าน</h1>
			<div class="text-center">หากท่านลืมรหัสผ่าน กรุณาใส่ Email หรือ username ที่เคยลงทะเบียนไว้ ลงในช่องด้านล่าง</div>
			<div class="d-flex align-items-center pb-2">
				<b-form-input v-model="email"/>
			</div>
			<div class="text-center">
				<b-button class="ml-1" variant="primary" @click="updatePassword()">ทำการกู้รหัสผ่าน</b-button>
			</div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton,
} from 'bootstrap-vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'Taobao2youUpdatePassword',

  components: {
    BCard, BRow, BCol, BFormInput, BButton,
   },

  data() {
    return {
      email: '',
    };
  },

  methods: {
    async updatePassword() {
      let response = await axios.post(
        taobaoService_dotnet + '/app/Customer/forget-password',
        {
          "email": this.email
        },
        { headers: header_token }
      );
    },
  },
};
</script>

<style lang="scss" scoped>

</style>